(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-logos"] && !Shopify.designMode) return;
  try {
    
  class BrandCarousel extends HTMLElement {
    connectedCallback() {
      if (this.dataset.brandCarouselReady === 'true') return;

      this.rail = this.querySelector('[data-brand-carousel-rail]');
      this.controls = this.querySelector('[data-brand-carousel-controls]');
      this.previousButton = this.querySelector('[data-brand-carousel-previous]');
      this.nextButton = this.querySelector('[data-brand-carousel-next]');
      this.status = this.querySelector('[data-brand-carousel-status]');
      this.items = Array.from(this.querySelectorAll('.brandstrip__item'));

      if (!this.rail || !this.controls || !this.previousButton || !this.nextButton) return;

      this.dataset.brandCarouselReady = 'true';
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };

      this.previousButton.addEventListener('click', () => this.scrollByPage(-1), options);
      this.nextButton.addEventListener('click', () => this.scrollByPage(1), options);
      this.rail.addEventListener('scroll', () => this.updateControls(), {
        passive: true,
        signal: this.controller.signal
      });
      window.addEventListener('resize', () => this.updateControls(), options);

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => this.updateControls());
        this.resizeObserver.observe(this.rail);
      }

      requestAnimationFrame(() => this.updateControls());
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
    }

    scrollByPage(direction) {
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const distance = Math.max(180, this.rail.clientWidth * 0.72);
      this.rail.scrollBy({
        left: direction * distance,
        behavior: reducedMotion ? 'auto' : 'smooth'
      });

      window.setTimeout(() => this.announceVisibleRange(), reducedMotion ? 0 : 320);
    }

    updateControls() {
      const maximum = Math.max(0, this.rail.scrollWidth - this.rail.clientWidth);
      const hasOverflow = maximum > 2;
      this.controls.hidden = !hasOverflow;
      this.previousButton.disabled = !hasOverflow || this.rail.scrollLeft <= 2;
      this.nextButton.disabled = !hasOverflow || this.rail.scrollLeft >= maximum - 2;
    }

    announceVisibleRange() {
      if (!this.status || this.items.length === 0) return;

      const railBounds = this.rail.getBoundingClientRect();
      const visible = this.items.filter((item) => {
        const bounds = item.getBoundingClientRect();
        return bounds.right > railBounds.left + 2 && bounds.left < railBounds.right - 2;
      });
      if (visible.length === 0) return;

      const first = this.items.indexOf(visible[0]) + 1;
      const last = this.items.indexOf(visible[visible.length - 1]) + 1;
      const template = this.dataset.statusTemplate || 'Showing brands __FIRST__ to __LAST__ of __TOTAL__';
      this.status.textContent = template
        .replace('__FIRST__', String(first))
        .replace('__LAST__', String(last))
        .replace('__TOTAL__', String(this.items.length));
    }
  }

  if (!customElements.get('brand-carousel')) {
    customElements.define('brand-carousel', BrandCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ganesh-bogo"] && !Shopify.designMode) return;
  try {
    
  class PaydayCurtain extends HTMLElement {
    connectedCallback() {
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let seen = false;

      try {
        seen = sessionStorage.getItem('luvee-payday-curtain-seen') === '1';
      } catch (error) {
        seen = false;
      }

      if (reducedMotion || seen) {
        this.remove();
        return;
      }

      try {
        sessionStorage.setItem('luvee-payday-curtain-seen', '1');
      } catch (error) {
        // Storage can be unavailable in strict privacy modes; the animation still works.
      }

      this.hidden = false;
      requestAnimationFrame(() => this.classList.add('payday-curtain--opening'));
      this.querySelector('.payday-curtain__panel--left')?.addEventListener('animationend', () => this.remove(), { once: true });
      this.cleanupTimer = window.setTimeout(() => this.remove(), 950);
    }

    disconnectedCallback() {
      window.clearTimeout(this.cleanupTimer);
    }
  }

  if (!customElements.get('payday-curtain')) customElements.define('payday-curtain', PaydayCurtain);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-track-order"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('luvee-order-tracker')) {
    class LuveeOrderTracker extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('[data-tracking-form]');
        this.error = this.querySelector('[data-tracking-error]');
        this.form?.addEventListener('submit', this.handleSubmit);
      }

      disconnectedCallback() {
        this.form?.removeEventListener('submit', this.handleSubmit);
      }

      handleSubmit = (event) => {
        event.preventDefault();
        const data = new FormData(event.currentTarget);
        const waybill = String(data.get('waybill') || '').trim();
        if (!/^[A-Za-z0-9-]{5,60}$/.test(waybill)) {
          this.error.textContent = 'Enter the waybill exactly as it appears in your dispatch message.';
          event.currentTarget.elements.waybill.setAttribute('aria-invalid', 'true');
          return;
        }
        this.error.textContent = '';
        event.currentTarget.elements.waybill.removeAttribute('aria-invalid');
        window.location.assign(`https://www.delhivery.com/track/package/${encodeURIComponent(waybill)}`);
      };
    }

    customElements.define('luvee-order-tracker', LuveeOrderTracker);
  }

  } catch(e) { console.error(e); }
})();
})();
